<div clientSideOnly *ngIf="isDataReady"
    class="px-2 fixed ltr:right-0 rtl:left-0 bottom-[100px] lg:bottom-[186px] z-10 ltr:text-right rtl:text-left w-auto ltr:ml-0 block"
    [ngClass]="pageType">
    <ul class="flex-col gap-4 inline-flex">
        <li *ngIf="isSubSitesEnabled" (mouseover)="mouseover('star', $event)" (click)="onStarClick('star', $event)" (mouseout)="mouseout('star', $event)"
            class="widget-item widget-item-star relative z-[1]"

            [ngClass]="{
            'animation-start': isMouseOver.star,
            'animation-end': !isMouseOver.star,
            'animate-[fadeInUp_0.6s_1.1s_ease_both]': isDesktop,
            'animate-[fadeInRight_0.6s_1.1s_ease_both]': !isDesktop
            }"

            >
            <button type="button" class="relative w-[65px] h-[65px] group group-parent">
                <app-svg class="icon-container star-container absolute top-0 left-0 rotate-90 drop-shadow-widget"
                    src="assets/svgs/polygon.svg" label="title_goas_here" [stretch]="false" width="65" height="65"
                    fill="var(--primary-color)"></app-svg>
                <div class="relative z-10 w-full h-full flex items-center justify-center pb-1">

                    <img [defaultImage]="'assets/images/placeholder.webp'| imageSource"
                        [errorImage]="'errorImage'| imageSource" [lazyLoad]="(isDesktop ? starWidget.desktopIcon : starWidget.icon) | imageSource"
                        alt="title_goas_here" width="40" height="39" class="w-10 h-[39px]" />

                </div>
                <div class="content-1 overflow-auto w-0 absolute h-[35px] ltr:right-[57px] rtl:left-[57px] top-[15px]">
                </div>
                <div
                    class="content-2 overflow-auto w-0 h-[165px] absolute ltr:right-[79px] rtl:left-[79px] bg-[var(--primary-color)] top-0 rounded-[5px] font-Poppins-Light text-sm tracking-normal text-white flex items-center justify-center star-widget-inner"
                    [class.mobile-down]="!isDesktop"
                    >

                    <div *ngIf="starWidget.isDataShown" class="flex flex-col items-center justify-center rounded-[5px]">

                        <div *ngFor="let row of starWidget.list" class="flex flex-row items-center justify-center">

                            <div *ngFor="let rowItem of row" class="border border-white">
                                <a *ngIf="isExternalMethod(rowItem.link)" [href]="rowItem.link |routeLocalization"
                                    routerLinkActive="link-active" target="_blank"
                                    class="star-item w-[101px] h-[82px] ltr:border-r rtl:border-l ltr:last:border-r-transparent rtl:last:border-l-transparent border-white flex justify-center items-center transition-all">
                                    <img [width]="rowItem.width" [height]="rowItem.height" [alt]="rowItem.alt"
                                        class="p-2" [title]="rowItem.title" [src]="rowItem.src | imageSource" />
                                </a>
                                <a *ngIf="!isExternalMethod(rowItem.link)"
                                    [routerLink]="rowItem.link | routeLocalization" routerLinkActive="link-active"
                                    class="star-item w-[101px] h-[82px] ltr:border-r rtl:border-l ltr:last:border-r-transparent rtl:last:border-l-transparent border-white flex justify-center items-center transition-all">
                                    <img [width]="rowItem.width" [height]="rowItem.height" [alt]="rowItem.alt"
                                        class="p-2" [title]="rowItem.title" [src]="rowItem.src | imageSource" />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </button>
        </li>

        <ng-container *ngIf="isChatEnabled">
            <ng-container *ngTemplateOutlet="widgetItem; context: { content: chatWidget }"></ng-container>
        </ng-container>
        <ng-container *ngIf="isNotificationEnabled">
            <ng-container *ngTemplateOutlet="widgetItem; context: { content: notificationWidget }"></ng-container>
        </ng-container>
    </ul>
</div>


<ng-template #widgetItem let-content="content">
    <li (mouseover)="mouseover(content.content, $event)" (mouseout)="mouseout(content.content, $event)"
        class="widget-item widget-item-normal" (click)="fireEvent(content.content)"
        [class]="[content.animation,isMouseOver[content.content] ? 'animation-start' : 'animation-end']">
        <button type="button" class="relative w-[65px] h-[65px] group group-parent">
            <app-svg class="icon-container absolute top-0 left-0 rotate-90 drop-shadow-widget"
                [class]="content.hoverClass" src="assets/svgs/polygon.svg" label="polygon" [stretch]="false" width="65"
                height="65" [fill]="content.polygonColor"></app-svg>
            <div class="relative z-10 w-full h-full flex items-center justify-center pb-1">
                <app-notification-counter *ngIf="content.notification"
                    [count]="content.notification"></app-notification-counter>

                <img [defaultImage]="'assets/images/placeholder.webp'| imageSource"
                    [errorImage]="'errorImage'| imageSource" [lazyLoad]="content.icon | imageSource"
                    [alt]="content.content" [width]="content.width" [height]="content.height" />

            </div>
            <div class="content-1 w-0 absolute h-[35px] ltr:right-[57px] rtl:left-[57px] top-[15px]"
                [class]="content.backgroundColor">
            </div>
            <div class="content-2 w-0 h-[35px] absolute ltr:right-[79px] rtl:left-[79px] top-[15px] font-Poppins-Light text-sm tracking-normal text-white flex items-center justify-center rounded-tl-[5px] rounded-bl-[5px] "
                [class]="content.backgroundColor">

                <a *ngIf="content.notification" class="px-[30px] py-2 ml-[23px]  whitespace-nowrap"
                    [routerLink]="content.link | routeLocalization"
                    [innerHTML]="content.title[isRTL ? 'ar' : 'en'] | htmlSanitizer"></a>

                <button *ngIf="content.content === 'chat'" type="button"
                    class="px-[30px] py-2 ml-[23px] whitespace-nowrap"
                    [innerHTML]="content.title[isRTL ? 'ar' : 'en'] | htmlSanitizer"></button>
            </div>
        </button>
    </li>
</ng-template>